import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  const handleResetPassword = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await api.post('/api/auth/reset-password', {
        token,
        password,
      });

      setMessage(response.data.message || t("password_reset_success"));
    } catch (error) {
      setMessage('Error: ' + (error.response?.data?.error || t("password_reset_failed")));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={5}>
      <Typography variant="h4" gutterBottom>
  {t('auth.resetPasswordTitle')}
</Typography>
<form onSubmit={handleResetPassword}>
  <TextField
    label={t('auth.newPassword')}
    type="password"
    fullWidth
    margin="normal"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
  />
  <Button variant="contained" color="primary" type="submit" fullWidth disabled={isSubmitting}>
    {isSubmitting ? t('auth.resetting') : t('auth.resetPassword')}
  </Button>
</form>
        {message && (
          <Typography color={message.includes('Error') ? 'error' : 'primary'} mt={2}>
            {message}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default ResetPassword;
